
export const VisaIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='37'
    height='22'
    fill='none'
    viewBox='0 0 37 22'
  >
    <path
      fill='#21569A'
      d='M.022 1.75c0-.464.181-.91.504-1.238A1.7 1.7 0 0 1 1.744 0H34.28c.466-.004.914.176 1.25.503.337.327.535.774.552 1.247v11.067c0 .464-.182.91-.505 1.237a1.7 1.7 0 0 1-1.218.513H1.828a1.78 1.78 0 0 1-1.252-.503 1.83 1.83 0 0 1-.553-1.247z'
    />
    <path
      fill='#F4AD0F'
      d='M.19 8.023h34.266c.44-.002.863.173 1.176.487.314.315.491.742.494 1.19v.045l.145 10.333c0 .464-.181.909-.504 1.237a1.7 1.7 0 0 1-1.218.512H1.992a1.78 1.78 0 0 1-1.25-.504 1.83 1.83 0 0 1-.551-1.245z'
    />
    <path fill='#fff' d='m36.285 17.139-36.28-.004V4.58l36.125-.014z' />
    <path
      fill='#21569A'
      d='m17.695 7.248-1.89 8.72h-2.346l1.984-8.702zm9.741 5.599 1.171-3.3.724 3.3zm2.525 3.114h2.177l-1.891-8.702h-1.984c-.208.001-.411.062-.587.175a1.1 1.1 0 0 0-.405.465l-3.445 8.048h2.456l.451-1.281h2.994l.268 1.28zm-5.952-2.848c0-2.292-3.245-2.383-3.245-3.5 0-.276.269-.643.992-.734a4.74 4.74 0 0 1 2.253.367l.344-1.834a6.7 6.7 0 0 0-2.166-.35c-2.253 0-3.875 1.19-3.875 2.838 0 1.284 1.17 1.925 1.984 2.383.902.459 1.17.732 1.17 1.099 0 .55-.719.826-1.353.826a4.7 4.7 0 0 1-2.342-.55l-.344 1.921a6.2 6.2 0 0 0 2.524.459c2.436 0 3.968-1.099 4.058-2.925M14.45 7.248l-3.696 8.72H8.226L6.425 9.005a.8.8 0 0 0-.157-.454.8.8 0 0 0-.384-.281 11 11 0 0 0-2.256-.735l.09-.273h3.878c.26-.007.512.082.711.251.2.169.331.405.37.666l.993 5.038 2.435-5.864 2.346-.091z'
    />
  </svg>
);


